module.exports = __webpack_public_path__ + "fonts/Inter-600-cyrillic58.de93fdc.woff2";